import { images } from './images';

export interface Product {
  id: number;
  title: string;
  titleAr: string;
  description: string;
  descriptionAr: string;
  category: string;
  subcategory: string;
  image: string;
  images: string[];
  price: number;
  featured?: boolean;
}

export interface CategoryInfo {
  id: string;
  name: string;
  nameAr: string;
  subcategories: SubcategoryInfo[];
}

export interface SubcategoryInfo {
  id: string;
  name: string;
  nameAr: string;
}

// Category definitions - empty, will be fetched from API
export const categories: CategoryInfo[] = [];

// Products - empty, will be fetched from API
export const products: Product[] = [];

export interface Partner {
  id: number;
  name: string;
  logo: string;
}

export const partners: Partner[] = [
  { id: 1, name: 'Partner 1', logo: images.partners.partner1 },
  { id: 2, name: 'Partner 2', logo: images.partners.partner2 },
  { id: 3, name: 'Partner 3', logo: images.partners.partner3 },
 { id: 4, name: 'Partner 4', logo: images.partners.partner1 },
  { id: 5, name: 'Partner 5', logo: images.partners.partner2 },
  { id: 6, name: 'Partner 6', logo: images.partners.partner3 }
];

// Helper functions
export const getSubcategoryInfo = (categoryId: string, subcategoryId: string): SubcategoryInfo | undefined => {
  const category = categories.find(cat => cat.id === categoryId);
  return category?.subcategories.find(sub => sub.id === subcategoryId);
};

export const getCategoryInfo = (categoryId: string): CategoryInfo | undefined => {
  return categories.find(cat => cat.id === categoryId);
};